import {
  DvGridComponent,
  DvQuickFilterComponent,
  DvGridToolbarComponent,
  DvActionComponent,
} from '@devinco/ui/grid';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { pendingChangesGuard } from '@core/guards/pending-changes.guard';
import {
  DvDynamicFormModule,
  DvNavTabsModule,
  DvSavePanelModule,
} from '@devinco/ui/legacy';
import { TranslateModule } from '@ngx-translate/core';
import { POIInformationTabComponent } from './components/tabs/poi-information-tab/poi-information-tab.component';
import { POITabsComponent } from './components/tabs/poi-tabs/poi-tabs.component';
import { AddressSearchResultBoxComponent } from '@shared/components/address-search-result-box/address-search-result-box.component';
import { DirectivesModule } from '@shared/directives/directives.module';
import { MapModule } from '@features/map/map.module';
import { AgGridModule } from 'ag-grid-angular';
import { MapAddressSearchFormComponent } from '@shared/components/map-address-search-form/map-address-search-form.component';
import { PoiPageComponent } from './poi-page.component';
import { PipesModule } from '@shared/pipes/pipes.module';
import { DvButtonComponent } from '@devinco/ui/dds';

import { DvVerticalSplitterComponent } from '@devinco/ui/dds/splitter';
import { POIGridComponent } from './components/poi-grid/poi-grid.component';

export const POIRouteName = {
  Main: 'poi',
  Information: 'information',
};

const routes: Routes = [
  {
    path: '',
    component: PoiPageComponent,
    children: [
      {
        path: ':id',
        pathMatch: 'full',
        redirectTo: `:id/${POIRouteName.Information}`,
      },
      {
        path: ':id',
        component: POITabsComponent,
        children: [
          {
            path: POIRouteName.Information,
            component: POIInformationTabComponent,
            canDeactivate: [
              (component: POIInformationTabComponent) =>
                pendingChangesGuard(component),
            ],
          },
        ],
      },
    ],
  },
];

@NgModule({
  declarations: [
    PoiPageComponent,
    POIGridComponent,
    POIInformationTabComponent,
  ],
  imports: [
    POITabsComponent,
    CommonModule,
    RouterModule.forChild(routes),
    AgGridModule,
    DvButtonComponent,
    DirectivesModule,
    DvGridComponent,
    DvQuickFilterComponent,
    DvGridToolbarComponent,
    DvActionComponent,
    TranslateModule,
    MapModule,
    DvNavTabsModule,
    DvDynamicFormModule,
    PipesModule,
    DvSavePanelModule,
    AddressSearchResultBoxComponent,
    DvVerticalSplitterComponent,
    MapAddressSearchFormComponent,
  ],
})
export class PoiPageModule {}
